export default __webpack_public_path__ + "static/media/account-icon.8b5e2e7e.svg";